import Title from "../../components/ui/Title"
import { Link } from "react-router-dom"
import Button from "../../components/ui/Button"
import '../../styles/pages/system.scss'

const Arts = () => {
    return (
        <div className="page-container">
            <Title
                text="System"
                size="full"
            />
            <div className="line-container">
            <header className="system-header">
                <h1 className="system-title">
                    Introducing the Enigma! The latest in orbal tech!
                </h1>
                <p>
                    The latest model of combat orbment, the Enigma is able to power its users up and allow them to cast even more potent orbal arts than ever before!
                </p>
            </header>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Quartz
                    </h1>
                    <p>
                        Quartz are refined septium gemstones whose true power can be drawn out by orbments, enhancing the stats of the characters they're equipped to. In addition, different combinations of quartz will allow your characters to cast an array of different orbal arts at the cost of their EP (Energy Points).
                    </p>
                </div>
            </div>
            <div className="system-pair"  style={{paddingBottom: '25px'}}>
                <div className="system-info">
                    <h1 className="system-info_title">
                        Arts
                    </h1>
                    <p>
                        Make full use of your array of quartz and turn the tide of battle with powerful attack or support arts.
                    </p>
                    <div className="system-info_image">
                        <img src={`${process.env.PUBLIC_URL}/img/ss/arts-1.webp`} alt="AT Battle Images" />
                    </div>
                </div>
                <div className="vertical-pair">
                    <div className="vertical-info">
                        <h1>Chrono Drive</h1>
                        <p>
                            A time-element support art.
                            <br/>
                            Grants all allies within a certain range increased speed for several turns.
                        </p>
                    </div>
                </div>
                <div className="vertical-pair">
                    <div className="vertical-info">
                        <h1>Avalon Gate</h1>
                        <p>
                            A mirage-element attack art.
                            <br/>
                            Opens heaven's gate and brings judgment's light to evil.
                        </p>
                    </div>
                    <div className="system-info_image">
                        <img src={`${process.env.PUBLIC_URL}/img/ss/arts-2.webp`} alt="" />
                    </div>
                </div>
            </div>
            <Link to="/system">
                <Button
                    text="Go Back"
                    type="solid"
                />
            </Link>
            </div>
        </div>
    )
}

export default Arts